import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "results", "form", "selectedName", "userId", "userName"];
  static values  = { url: String, exclude: Array, noResults: String };

  connect() {
    this._timeout = null;
    document.addEventListener("click", this._onOutsideClick.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this._onOutsideClick.bind(this));
  }

  search() {
    clearTimeout(this._timeout);
    const query = this.inputTarget.value.trim();
    if (query.length < 2) { this._clearResults(); return; }
    this._timeout = setTimeout(() => this._fetchResults(query), 300);
  }

  handleKey(event) {
    if (event.key === "Escape") { this.cancel(); }
  }

  selectUser(event) {
    const { id, name } = event.currentTarget.dataset;
    this.userIdTarget.value   = id;
    this.userNameTarget.value = name;
    this.selectedNameTarget.value = name;
    this._clearResults();
    this.formTarget.classList.remove("d-none");
    this.inputTarget.classList.add("d-none");
  }

  cancel() {
    this.formTarget.classList.add("d-none");
    this.inputTarget.classList.remove("d-none");
    this.inputTarget.value = "";
    this.userIdTarget.value   = "";
    this.userNameTarget.value = "";
    this._clearResults();
  }

  async _fetchResults(query) {
    try {
      const resp  = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`);
      const users = await resp.json();
      this._showResults(users);
    } catch (_) {
      this._clearResults();
    }
  }

  _showResults(users) {
    const excluded = this.hasExcludeValue ? this.excludeValue : [];
    users = users.filter(u => !excluded.includes(u.id));
    this.resultsTarget.innerHTML = "";
    users.forEach(user => {
      const li  = document.createElement("li");
      const btn = document.createElement("button");
      btn.type      = "button";
      btn.className = "dropdown-item";
      btn.textContent = user.name;
      btn.dataset.id   = user.id;
      btn.dataset.name = user.name;
      btn.dataset.action = "click->member-search#selectUser";
      li.appendChild(btn);
      this.resultsTarget.appendChild(li);
    });
    if (users.length === 0) {
      const li = document.createElement("li");
      li.className = "dropdown-item text-muted disabled";
      li.textContent = this.noResultsValue;
      this.resultsTarget.appendChild(li);
    }
    this.resultsTarget.classList.add("show");
  }

  _clearResults() {
    this.resultsTarget.innerHTML = "";
    this.resultsTarget.classList.remove("show");
  }

  _onOutsideClick(event) {
    if (!this.element.contains(event.target)) { this._clearResults(); }
  }
}
